import { render, staticRenderFns } from "./add-pay-record.vue?vue&type=template&id=b53a5a36&"
import script from "./add-pay-record.vue?vue&type=script&lang=js&"
export * from "./add-pay-record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports